export const palette = {
    primary: {
        0: '#000000',
        10: '#001c38',
        20: '#00315b',
        30: '#004881',
        40: '#0060a9',
        50: '#0079d2',
        60: '#3994ef',
        70: '#6baeff',
        80: '#a2c9ff',
        90: '#d3e4ff',
        95: '#eaf1ff',
        99: '#fdfcff',
        100: '#ffffff',
    },
    secondary: {
        0: '#000000',
        10: '#111c2b',
        20: '#263141',
        30: '#3c4758',
        40: '#545f70',
        50: '#6c788a',
        60: '#8691a4',
        70: '#a0acbf',
        80: '#bbc7db',
        90: '#d7e3f8',
        95: '#eaf1ff',
        99: '#fdfcff',
        100: '#ffffff',
    },
    tertiary: {
        0: '#000000',
        10: '#261431',
        20: '#3c2947',
        30: '#533f5e',
        40: '#6c5677',
        50: '#866f91',
        60: '#a188ac',
        70: '#bca2c7',
        80: '#d8bde3',
        90: '#f5d9ff',
        95: '#fcebff',
        99: '#fffbff',
        100: '#ffffff',
    },
    error: {
        0: '#000000',
        10: '#410002',
        20: '#690005',
        30: '#93000a',
        40: '#ba1a1a',
        50: '#de3730',
        60: '#ff5449',
        70: '#ff897d',
        80: '#ffb4ab',
        90: '#ffdad6',
        95: '#ffedea',
        99: '#fffbff',
        100: '#ffffff',
    },
    neutral: {
        0: '#000000',
        10: '#1a1c1e',
        20: '#2f3033',
        30: '#46474a',
        40: '#5d5e61',
        50: '#76777a',
        60: '#909094',
        70: '#ababae',
        80: '#c6c6ca',
        90: '#e3e2e6',
        95: '#f1f0f4',
        99: '#fdfcff',
        100: '#ffffff',
    },
    neutralVariant: {
        0: '#000000',
        10: '#181c22',
        20: '#2c3137',
        30: '#43474e',
        40: '#5a5e66',
        50: '#73777f',
        60: '#8d9199',
        70: '#a8abb4',
        80: '#c3c6cf',
        90: '#dfe2eb',
        95: '#eef1fa',
        99: '#fdfcff',
        100: '#ffffff',
    },
    success: {
        0: '#000000',
        10: '#00210c',
        20: '#003919',
        30: '#005227',
        40: '#006d35',
        50: '#008945',
        60: '#00a755',
        70: '#25c469',
        80: '#4de082',
        90: '#6dfe9b',
        95: '#c4ffcd',
        99: '#f5fff3',
        100: '#ffffff',
    },
    warning: {
        0: '#000000',
        10: '#231a00',
        20: '#3c2f00',
        30: '#574500',
        40: '#735c00',
        50: '#917400',
        60: '#af8d00',
        70: '#cda724',
        80: '#eac23f',
        90: '#ffe087',
        95: '#fff0cb',
        99: '#fffbff',
        100: '#ffffff',
    },

    // V4
    'jarivis-neutral': {
        0: '#ffffff',
        10: '#cccccc',
        20: '#aaaaaa',
        30: '#808080',
        40: '#555555',
        50: '#2b2b2b',
        100: '#000000'
    }
}

export const primary = {
    primary: {
        _light: 'primary.50',
        _dark: 'primary.80',
    },
    onPrimary: {
        _light: 'primary.100',
        _dark: 'primary.20',
    },
    primaryContainer: {
        _light: 'primary.90',
        _dark: 'primary.30',
    },
    onPrimaryContainer: {
        _light: 'primary.10',
        _dark: 'primary.90',
    },
}

export const secondary = {
    secondary: {
        _light: 'secondary.40',
        _dark: 'secondary.80',
    },
    onSecondary: {
        _light: 'secondary.100',
        _dark: 'secondary.20',
    },
    secondaryContainer: {
        _light: 'secondary.90',
        _dark: 'secondary.30',
    },
    onSecondaryContainer: {
        _light: 'secondary.10',
        _dark: 'secondary.90',
    },
}

export const tertiary = {
    tertiary: {
        _light: 'tertiary.40',
        _dark: 'tertiary.80',
    },
    onTertiary: {
        _light: 'tertiary.100',
        _dark: 'tertiary.20',
    },
    tertiaryContainer: {
        _light: 'tertiary.90',
        _dark: 'tertiary.30',
    },
    onTertiaryContainer: {
        _light: 'tertiary.10',
        _dark: 'tertiary.90',
    },
}

export const error = {
    error: {
        _light: 'error.40',
        _dark: 'error.80',
    },
    onError: {
        _light: 'error.100',
        _dark: 'error.20',
    },
    errorContainer: {
        _light: 'error.90',
        _dark: 'error.30',
    },
    onErrorContainer: {
        _light: 'error.10',
        _dark: 'error.90',
    },
 
}

export const background = {
    background: {
        _light: 'neutral.99',
        _dark: 'neutral.10',
    },
    onBackground: {
        _light: 'neutral.10',
        _dark: 'neutral.90',
    },
}

export const surface = {
    surface: {
        _light: 'neutral.99',
        _dark: 'neutral.10',
    },
    onSurface: {
        _light: 'neutral.10',
        _dark: 'neutral.90',
    },
    calendarSurface: {
        _light: 'neutral.20',
        _dark: 'neutral.50'
    }
}

export const onSurfaceVariant = {
    surfaceVariant: {
        _light: 'neutralVariant.90',
        _dark: 'neutralVariant.30',
    },
    onSurfaceVariant: {
        _light: 'neutralVariant.30',
        _dark: 'neutralVariant.80',
    },
}

export const outline = {
    outline: {
        _light: 'neutralVariant.50',
        _dark: 'neutral.60',
    },
    outlineVariant: {
        _light: 'neutralVariant.50',
        _dark: 'neutralVariant.60'
    }
}

export const success = {
    success: {
        _light: 'success.40',
        _dark: 'success.80',
    },
    onSuccess: {
        _light: 'success.100',
        _dark: 'success.20',
    },
    successContainer: {
        _light: 'success.90',
        _dark: 'success.30',
    },
    onSuccessContainer: {
        _light: 'success.10',
        _dark: 'success.90',
    },
    finishedContainer: {
        _light: palette.success[10],
        _dark: palette.success[95],
    }
}

export const warning = {
    warning: {
        _light: 'warning.40',
        _dark: 'warning.80',
    },
    onWarning: {
        _light: 'warning.100',
        _dark: 'warning.20',
    },
    warningContainer: {
        _light: 'warning.90',
        _dark: 'warning.30',
    },
    onWarningContainer: {
        _light: 'warning.10',
        _dark: 'warning.90',
    },
 
}

export const surfacePlus = {
    surfacePlus1: {
        _light: '#f0f4fa',
        _dark: '#212529',
    },
    surfacePlus2: {
        _light: '#e9f0f9',
        _dark: '#252a30',
    },
    surfacePlus3: {
        _light: '#e1ebf6',
        _dark: '#292f37',
    },
    surfacePlus4: {
        _light: '#dee9f4',
        _dark: '#2a3139',
    },
    surfacePlus5: {
        _light: '#d9e5f3',
        _dark: '#2d343e',
    },
}

export const chakra = {
    'chakra-body-bg': {
        _dark: background.background._dark,
        _light: background.background._light,
    },
    // 'chakra-body-text': {
    //     _dark: background.onBackground._dark,
    //     _light: background.onBackground._light,
    // },
    // 'chakra-placeholder-color': {
    //     _dark: surface.surface._dark,
    //     _light: surface.surface._light,
    // },
    // 'chakra-border-color': {
    //     _dark: outline.outline._dark,
    //     _light: outline.outline._light,
    // },
}

export const v4SemanticColors = {
  'Jarivis-Success-Main': {
    _light: '#006d35',
    _dark: '#006d35',
  },
  'Jarivis-Success-Surface': {
    _light: '#deffee',
    _dark: '#deffee',
  },
  'Jarivis-Success-Border': {
    _light: '#006d35',
    _dark: '#006d35',
  },
  'Jarivis-Success-Hover': {
    _light: '#004923',
    _dark: '#004923',
  },
  'Jarivis-Success-Pressed': {
    _light: '#00371b',
    _dark: '#00371b',
  },

  'Jarivis-Danger-Main': {
    _light: '#cb0003',
    _dark: '#cb0003',
  },
  'Jarivis-Danger-Surface': {
    _light: '#ffddde',
    _dark: '#ffddde',
  },
  'Jarivis-Danger-Border': {
    _light: '#cb0003',
    _dark: '#cb0003',
  },
  'Jarivis-Danger-Hover': {
    _light: '#870002',
    _dark: '#870002',
  },
  'Jarivis-Danger-Pressed': {
    _light: '#660002',
    _dark: '#660002',
  },

  'Jarivis-Orange-Main': {
    _light: '#ffa500',
    _dark: '#ffa500',
  },
  'Jarivis-Orange-Border': {
    _light: '#ffa500',
    _dark: '#ffa500',
  },
  'Jarivis-Orange-Hover': {
    _light: '#805300',
    _dark: '#805300',
  },
  'Jarivis-Orange-Pressed': {
    _light: '#d48900',
    _dark: '#d48900',
  },
  'Jarivis-Orange-Surface': {
    _light: '#ffedcc',
    _dark: '#ffedcc',
  },

  'Jarivis-Blue-Main': {
    _light: '#0079d2',
    _dark: '#0079d2',
  },
  'Jarivis-Blue-Border': {
    _light: '#0079d2',
    _dark: '#0079d2',
  },
  'Jarivis-Blue-Hover': {
    _light: '#003d69',
    _dark: '#003d69',
  },
  'Jarivis-Blue-Pressed': {
    _light: '#0065af',
    _dark: '#0065af',
  },
  'Jarivis-Blue-Surface': {
    _light: '#eaf6ff',
    _dark: '#eaf6ff',
  },
}
